import React from 'react';
import { number, string, func, shape } from 'prop-types';
import styles from './styles/styles.module.scss';

const RiverImage = ({ photo, className, onClick }) => {
  return <img className={`${styles.riverImage} ${className}`} alt={photo.caption} src={photo.imgUrl} onClick={onClick} />;
};

RiverImage.propTypes = {
  photo: shape({
    id: number,
    imgUrl: string,
    caption: string // caption prop incoming https://alltrails.atlassian.net/browse/SVR-4513
  }).isRequired,
  className: string,
  onClick: func
};

RiverImage.defaultProps = {
  className: '',
  onClick: () => {}
};

export default RiverImage;
